<template>
  <div>
    <b-card
      title="Terms and Conditions Enable Setting"
    >
      <b-overlay
        :show="loading"
        blur="10px"
        opacity="0.30"
        rounded="sm"
        variant="light"
      >
        <b-form
          @submit.prevent
          @submit="changeTermsandConditionStatus"
        >
          <b-row>
            <b-card>
              <b-form-radio-group
                v-model="merchantTerm"
                :options="radioOptions"
                class="demo-inline-spacing mb-1"
                value-field="value"
                text-field="text"
                disabled-field="disabled"
                @change="changeTermsandConditionStatus"
              />
            </b-card>
          </b-row>
          <b-row>
            <div class="ml-2">
              When this settings is enabled, the terms and conditions will be displayed to merchants, requiring them to read and agree to them during the account registration process.
            </div>
          </b-row>
        </b-form>
      </b-overlay>
    </b-card>
    <b-card-actions
      v-if="merchantTerm"
      title="Filters"
      action-collapse
      collapsed
    >
      <b-row>
        <b-col md="3">
          <b-form-group
            label="Created Date"
            label-for="created_date"
          >
            <div class="position-relative">
              <AdvancedDateFilter
                :date-value="filters['created_at']"
                :opens="'right'"
                @update="updateDateRange('created_at', $event)"
              />
            </div>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group
            label="Version Number"
            label-for="version_number"
          >
            <b-form-input
              id="version_number"
              v-model="filters['version_number']"
              placeholder="Search"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group
            label="Status"
            label-for="status"
          >
            <v-select
              id="status"
              v-model="filters['is_active']"
              :options="statusOptions"
              :reduce="option => option.key"
              label="name"
              placeholder="Select Status"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <!-- Apply and Clear Filters -->
      <b-row class="mt-1">
        <b-col>
          <filter-buttons
            :filter-data="filters"
            :apply-filters="applyFilters"
            :clear-filters="clearFilters"
          />
        </b-col>
      </b-row>
    </b-card-actions>
    <b-card
      v-if="merchantTerm"
      no-body
    >
      <div>
        <b-row>
          <b-col
            cols="12"
            md="8"
          >
            <b-row class="d-sm-flex align-items-start">
              <b-col
                md="12"
                lg="8"
                class="d-block d-sm-flex flex-wrap justify-content-start align-items-center mt-1 mb-md-0"
              >
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  class="ml-1 mr-1 add-custom-margin custom-button-color"
                  @click="onClickOpenAddNewTermsAndConditionsModal()"
                >
                  <feather-icon icon="PlusIcon" />
                  Add New
                </b-button>
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  class="mr-1 add-custom-margin custom-button-color"
                  @click="onClickOpenUploadPdfModel()"
                >
                  <feather-icon icon="UploadCloudIcon" />
                  Upload Pdf
                </b-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0  mt-1 mr-1"
          >
            <ReportTableButtons
              :items="rows"
              :json_fieldz="json_fields"
              :name="`Terms-And-Conditions - Page ${page}.xls`"
              :bulkname="`Terms-And-Conditions.xls`"
              :fetch="fetchDataForTermsAndConditionsNoPagination"
              @refresh="onClickRefresh"
            />
          </b-col>
        </b-row>
      </div>
      <b-overlay
        id="overlay-background"
        class="mt-2"
        blur="10px"
        opacity="0.30"
        rounded="sm"
        variant="light"
      >
        <b-table
          hover
          responsive
          striped
          show-empty
          :per-page="perPage"
          :items="rows"
          :fields="fields"
          class="hide-vertical-scroll"
        >
          <template #empty>
            <TableDataFetching
              :rows="rows"
              :data-loading="dataLoading"
            />
          </template>
          <template #cell(version_number)="data">
            <div class="d-flex align-items-start">
              {{ data.value }}
            </div>
          </template>
          <template #cell(created_at)="data">
            <div class="d-flex align-items-start">
              {{ __dateTimeFormatter(data.value) || '---' }}
            </div>
          </template>
          <template #cell(staff)="data">
            <div class="d-flex align-items-start">
              {{ data.item.staff.first_name }} {{ data.item.staff.last_name }}
            </div>
          </template>
          <template #cell(updated_at)="data">
            <div
              v-if="data.item.created_at !== data.item.updated_at"
              class="d-flex align-items-start"
            >
              {{ __dateTimeFormatter(data.value) || '---' }}
            </div>
          </template>
          <template #cell(is_active)="data">
            <div class="d-flex align-items-start">
              <div v-if="data.value === 1">
                <b-badge variant="light-success">
                  Active
                </b-badge>
              </div>
              <div v-if="data.value === 0">
                <b-badge variant="light-danger">
                  Inactive
                </b-badge>
              </div>
            </div>
          </template>
          <template #cell(action)="data">
            <div class="d-flex align-items-start">
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                :class="rows.length !== 1 ? 'dropdown-no-scroll':''"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="12"
                    class="text-body align-middle"
                  />
                </template>
                <b-dropdown-item
                  @click="onClickEditTermsAndCondition(data.item.id)"
                >
                  <feather-icon icon="EditIcon" />
                  Edit
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="!data.item.is_active"
                  @click="onClickDelete(data.item.id)"
                >
                  <feather-icon icon="ToolIcon" />
                  Delete
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </b-table>
      </b-overlay>
      <div class="mx-2 mb-2">
        <b-row
          cols="12"
        >
          <b-col
            class="d-flex align-items-center justify-content-sm-start"
            md="3"
          >
            <label class="width-75">Per page</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="pageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block"
            />
          </b-col>
          <b-col
            md="9"
            class="d-flex align-items-center justify-content-end"
          >
            <span class="text-muted mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
            <b-pagination
              v-model="page"
              :per-page="perPage"
              :total-rows="(meta.total)? meta.total : 0"
              class="mb-0 mt-1 mt-sm-0"
              first-number
              last-number
              next-class="next-item"
              prev-class="prev-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <add-terms-and-conditions-modal ref="add_terms_and_conditions_modal" />
    <upload-terms-and-condition-pdf-modal ref="upload_terms_and_condition_pdf_modal" />
    <update-terms-and-conditions-modal ref="update_terms_and_conditions_modal" />
  </div>
</template>

<script>
import {
  BOverlay,
  BTable,
  BButton,
  BRow,
  BCard,
  BCol,
  BFormGroup,
  BFormInput,
  BDropdown,
  BDropdownItem,
  BPagination,
  BBadge,
  BFormRadioGroup,
  BForm,
} from 'bootstrap-vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import FilterButtons from '@/components/Filter/FilterButtons.vue'
import Filter from '@core/mixins/filter'
import AddTermsAndConditionsModal from '@/components/TermsAndConditions/AddTermsAndConditionsModal.vue'
import UpdateTermsAndConditionsModal from '@/components/TermsAndConditions/UpdateTermsAndConditionsModal.vue'
import UploadTermsAndConditionPdfModal from '@/components/TermsAndConditions/UploadTermsAndConditionPdfModal.vue'
import AdvancedDateFilter from '@/components/AdvancedDateFilter/AdvancedDateFilter.vue'

const MerchantSettingsRepository = RepositoryFactory.get('merchantSetting')

export default {
  components: {
    BOverlay,
    BTable,
    BButton,
    BCard,
    BCardActions,
    BCol,
    BFormGroup,
    BFormInput,
    FilterButtons,
    BRow,
    BDropdown,
    BDropdownItem,
    BPagination,
    AddTermsAndConditionsModal,
    UpdateTermsAndConditionsModal,
    UploadTermsAndConditionPdfModal,
    BBadge,
    BFormRadioGroup,
    BForm,
    AdvancedDateFilter,
  },
  directives: {
    Ripple,
  },
  mixins: [SuccessMessage, ErrorMessage, Filter],
  data() {
    return {
      dataLoading: false,
      loading: false,
      form: {},
      radioOptions: [
        { text: 'On', value: true },
        { text: 'Off', value: false },
      ],
      merchantTerm: false,
      sort: '',
      meta: {},
      perPage: 20,
      pageOptions: [10, 20, 50],
      totalRows: 1,
      page: 1,
      filters: {
        created_at: {
          startDate: null,
          endDate: null,
        },
      },
      statusOptions: [
        { name: 'Active', key: '1' },
        { name: 'Inactive', key: '0' },
      ],
      filterOn: [],
      fields: [
        {
          key: 'version_number', label: 'Version Number', sortable: true, thClass: ' text-left', tdClass: ' text-left',
        },
        {
          key: 'created_at', label: 'Created Date', sortable: true, thClass: ' text-left', tdClass: ' text-left',
        },
        {
          key: 'staff', label: 'Created By', sortable: true, thClass: ' text-left', tdClass: ' text-left',
        },
        {
          key: 'updated_at', label: 'Edited Date', sortable: true, thClass: ' text-left', tdClass: ' text-left',
        },
        {
          key: 'is_active', label: 'Status', sortable: true, thClass: ' text-left', tdClass: ' text-left',
        },
        {
          key: 'action', label: 'Action', sortable: false, thClass: ' text-left', tdClass: ' text-left',
        },
      ],
      json_fields: {
        'Version Number': 'version_number',
        'Created Date': 'created_at',
        'Created By': {
          callback: value => `"${value.staff !== null ? `${value.staff.first_name}` : 'N/A'} ${value.staff !== null && value.staff.last_name !== null ? `${value.staff.last_name}` : ''}"`,
        },
        'Edited Date': 'updated_at',
        Status: {
          field: 'is_active',
          callback: value => `"${value === 1 ? 'Active' : 'Inactive'}"`,
        },
      },
      rows: [],
      items: [],
    }
  },
  watch: {
    page() {
      this.fetchTermsAndConditionsVersions()
    },
    perPage() {
      this.fetchTermsAndConditionsVersions()
    },
  },
  mounted() {
    this.readMerchantSetting()
    this.fetchTermsAndConditionsVersions()
    this.updateFilterCount()
  },
  methods: {
    async readMerchantSetting() {
      this.loading = true
      try {
        const { data } = (await MerchantSettingsRepository.getMerchantSettingsResource()).data
        this.form = data
        this.merchantTerm = this.form.terms_and_condition_enabale
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async setMerchantSetting() {
      this.loading = true
      try {
        const payload = {
          terms_and_condition_enabale: String(this.merchantTerm),
        }
        const res = await MerchantSettingsRepository.updateTermsAndConditionStatus(payload)
        if (res.status === 200) {
          this.showSuccessMessage('Terms And Condition Updated Successfully')
        } else {
          this.showErrorMessage('Cannot Update Terms And Condition')
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.readMerchantSetting()
      this.loading = false
    },
    onClickOpenAddNewTermsAndConditionsModal() {
      this.$refs.add_terms_and_conditions_modal.openModal()
    },
    async fetchTermsAndConditionsVersions() {
      this.dataLoading = true
      this.rows = []
      const filterQuery = this.buildFilterQuery()
      try {
        const { data } = await MerchantSettingsRepository.fetchTermsAndConditionsVersions(filterQuery, this.page, this.perPage)
        this.rows = data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    // eslint-disable-next-line consistent-return
    async fetchDataForTermsAndConditionsNoPagination() {
      try {
        const filterQuery = this.buildFilterQuery()
        const { data } = await MerchantSettingsRepository.fetchDataForTermsAndConditionsNoPagination(filterQuery)
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async onClickDelete(id) {
      try {
        const res = await MerchantSettingsRepository.onClickDelete(id)
        if (res.status === 200) {
          this.showSuccessMessage('Terms and Conditions Deleted Successfully')
        } else {
          this.showErrorMessage('Cannot Delete Terms and Conditions')
        }
        this.fetchTermsAndConditionsVersions()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async onClickEditTermsAndCondition(id) {
      try {
        const res = await MerchantSettingsRepository.onClickEditTermsAndCondition(id)
        this.contentType = res.data.data.content_type
        if (this.contentType === 1) {
          this.editorContent = res.data.data.content
          this.$refs.update_terms_and_conditions_modal.openModal(id, this.editorContent)
        } else {
          this.$refs.upload_terms_and_condition_pdf_modal.openModal()
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    applyFilters() {
      this.fetchTermsAndConditionsVersions()
      this.updateFilterCount()
    },
    clearFilters() {
      this.filters = {
        created_at: {
          startDate: null,
          endDate: null,
        },
      }
      this.$nextTick(() => {
        this.fetchTermsAndConditionsVersions()
      })
      this.updateFilterCount()
    },
    onClickOpenUploadPdfModel() {
      this.$refs.upload_terms_and_condition_pdf_modal.openModal()
    },
    handleChangePage(page) {
      this.page = page
      this.fetchTermsAndConditionsVersions()
    },
    changePage(value) {
      this.perPage = value
    },
    onClickRefresh() {
      this.fetchTermsAndConditionsVersions()
    },
    async changeTermsandConditionStatus() {
      await this.setMerchantSetting()
    },
  },
}
</script>
  <style scoped>
  .custom-button-color {
    background-color: #4186f5 !important;
    border-color: #4186f5 !important;
  }
  @media (max-width: 767px) {
    .b-table thead th {
      position: sticky;
      top: 0;
    }
    .add-custom-margin {
      width: 90%;
      margin: 0.5rem 1rem 0.5rem 1rem;
    }
  }
  .per-page-selector {
    width: 125px;
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    .per-page-selector {
      width: 200px; /* Shrinks in tablet view */
    }
  }
  </style>
